import { EUserRole } from '../enums';
import { IBaseUser } from './base-user.interface';

export interface IUser extends IBaseUser {
  role: EUserRole;
}
